export default {
    data(){
        return {
            indeterminate: false,
            checkAll: false,
            newCheckAll: [],
        }
    },
    methods: {
        /**
         * 处理单选
         * @param {Array} number 所选数组
         */
        checkAllGroupChange(number) {
            let checkedIndex = this.newCheckAll.indexOf(number, 0);
            if (checkedIndex == -1) {
                this.newCheckAll.push(number);
            } else {
                this.newCheckAll.splice(checkedIndex, 1);
            }
            if (this.newCheckAll.length === this.listData.length) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (this.newCheckAll.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        /**
         * 处理全选
         */
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                this.newCheckAll = [];
                this.listData.map((item, index) => {
                    this.newCheckAll.push(item.id);
                });
            } else {
                this.newCheckAll = [];
            }
        },
        /**
         * 处理选中状态
         * @param {Array} number 所选数组
         */
        handleChecked(number) {
            let checkedIndex = this.newCheckAll.indexOf(number, 0);
            if (checkedIndex == -1) {
                return false;
            } else {
                return true;
            }
        }
    }
}